import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Font, PDFViewer, Page, Text, View, Document, StyleSheet, Svg, Circle, Path, Image } from "@react-pdf/renderer";
// import { lightGreen } from "@mui/material/colors";

Font.register({
    family: 'Calibri',
    fonts: [
        { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibri.ttf", format: 'truetype' },
        { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibrib.ttf", fontWeight: "bold", format: 'truetype' }
    ]
});

Font.register({
    family: 'Ubuntu',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'normal',
            fontStyle: 'italic',
        },
    ],
});
// Sample JSON object
const donutPositions = [
    { cx: 100, cy: 100 },
    { cx: 300, cy: 250 },
    { cx: 400, cy: 300 },
    { cx: 500, cy: 400 },
    { cx: 150, cy: 500 },
    { cx: 250, cy: 600 },
    { cx: 350, cy: 700 },
    { cx: 450, cy: 200 },
    { cx: 550, cy: 100 },
];

// PDF Component
const StudentPDF = (props) => {
    const lstGoals = ["Children develop habits that keep them healthy and safe."
                        , "Children develop sharpness in sensorial perceptions."
                        , "Children develop a fit and flexible body."];
    const lstAssessmentQuestion = ["How does child demonstrate coordination and balance while participating in ball activities, such as dribbling or catching a ball? Are they able to maintain control of the ball and adjust their movements to keep it in motion?"
        , "During group ball activities, how does child interact with peers? Do they take turns, collaborate, and show enthusiasm for playing with others? How well do they follow the rules and share the ball during team games?"
        , "How does child express different emotions during Emotion Charades activities? Are they able to accurately show feelings such as happiness, sadness, or anger through body language and facial expressions?"];
    const lstPerformanceDescriptor = [
        {
            "domainId": 1,
            "domain": "Physical Development",
            "comment": "The student demonstrates strong gross and fine motor skills. They actively engage in physical activities, showing increasing coordination and control in tasks like running, jumping, and catching. "
        },
        {
            "domainId": 2,
            "domain": "Socio-emotional Development",
            "comment": "The student is developing positive social skills and demonstrates increasing empathy in group settings. They interact well with peers, take turns, and express emotions more clearly."
        },
        {
            "domainId": 3,
            "domain": "Cognitive Development",
            "comment": "The student exhibits curiosity and problem-solving skills. They can follow simple instructions and engage in basic tasks with attention to detail."
        },
        {
            "domainId": 4,
            "domain": "Language and Literacy Development",
            "comment": "The student demonstrates a growing vocabulary and enjoys expressing themselves verbally. They actively participate in storytelling and discussions, and their ability to recognize letters and sounds is developing."
        },
        {
            "domainId": 5,
            "domain": "Aesthetic and Cultural Development",
            "comment": "The student engages actively in creative activities, such as drawing, music, and imaginative play. They are developing an appreciation for different forms of art and culture."
        },
        {
            "domainId": 6,
            "domain": "Positive Learning Habits",
            "comment": "The student is showing increasing independence in their learning activities. They follow routines and complete tasks with minimal prompting."
        }
    ];
    const lstFriend = ["Alice", "Bob", "Charlie"];
    const observationalNotes  = ["Demonstrates positive interactions with peers, showing a willingness to share and collaborate during group activities. They often take the role of a helper, showing empathy towards classmates who need assistance."
        , "Able to regulate emotions well, though they occasionally need reminders when feeling frustrated during challenging tasks. They are beginning to develop strategies to cope with these emotions, such as asking for a break when overwhelmed."
        , "Respond well to praise and often smile when receiving positive reinforcement, which boosts their confidence."
        , "Shows strong problem-solving skills. For example, when faced with a new puzzle, they will work through it methodically and ask insightful questions when they encounter difficulties."
        , "Their memory retention is notable as they can recall information from previous lessons and apply it to new situations. For instance, they were able to relate their learning about numbers to a new story problem introduced in class."
        , "Demonstrates curiosity and often asks questions that extend beyond the curriculum, showing a deep interest in learning."
        , "Developing strong verbal communication skills. They articulate their thoughts clearly and participate actively in class discussions. They enjoy expressing themselves and are able to narrate simple stories."
        , "Listens attentively to others in group settings and waits their turn to speak, showing respect for the communication process."
        , "enthusiastic and enjoys running, jumping, and playing games with their peers. They are working on improving their coordination and often take on leadership roles during group sports activities."];
    const myFavourite = {
        color: "Blue",
        flower: "Rose",
        food: "Pizza",
        sport: "Cricket",
        animal: "Dog",
        subject: "Math",
    }
    // Styles for the PDF
    const styles = StyleSheet.create({
        bgPartA2: {
            backgroundColor: props.partBColor//'#fee4a4'
        },
        page: {
            position: "relative",
            fontSize: 12,
            padding: 20,
            backgroundColor: props.partAColor//"#5e35b1",
        },
        f2: {
            flex: 2,
        },
        bDarkOrange: {
            border: '8px solid darkorange',
        },
        fDirectionRow: {
            flexDirection: 'row'
        },
        alignStart: {
            alignItems: 'flex-start'
        },
        fDirectionCol: {
            flexDirection: 'column'
        },
        justifyCenter: {
            justifyContent: 'center'
        },
        blueBorder: {
            border: '2px solid #0091cd',
        },
        bRadius70: {
            borderRadius: 70,
        },
        box100px: {
            height: 100,
            width: 100
        },
        alignCenter: {
            alignItems: 'center'
        },
        textBrown: {
            color: 'brown'
        },
        textBlue: {
            color: '#0091cd'
        },
        bgWhite: {
            backgroundColor: '#fff',
        },
        brownBorder: {
            border: '2px solid brown',
        },
        leftPart: {
            flex: 1
            , flexDirection: "column"
        },
        rightPart: {
            flex: 1, // Equal width for both sections
            flexDirection: "row",
            alignItems: "center"
        },
        header: {
            fontSize: 14,
            fontWeight: "bold",
            textAlign: 'center',
            textTransform: 'uppercase',
            color: '#000',
            backgroundColor: 'darkorange',
            // borderRadius: 6,
            padding: 5
        },
        section: {
            border: '1px solid darkorange',
            margin: 10,
            // backgroundColor: 'rgba(180, 180, 180, 0.4)'
        },
        gradeRow: {
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 5,
        },
        text: {
            fontSize: 12,
            zIndex: 2, // Ensures text is above the background
        },
        row: {
            flexDirection: "row",
            marginBottom: 5,
            alignItems: "center",
        },
        splitRow: {
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
        },
        firsthalf: {
            flex: 1, // Equal width for both sections
            flexDirection: "row",
            alignItems: "center"
        },
        secondhalf: {
            flex: 1, // Equal width for both sections
            flexDirection: "row",
            alignItems: "center"
        },
        label1: {
            width: "40%", // Allocate space for the label
            color: "#000",
            fontSize: 12,
            textAlign: "left", // Align labels to the right
            marginLeft: 5
        },
        label: {
            width: "20%", // Allocate space for the label
            color: "#000",
            fontSize: 11,
            textAlign: "left", // Align labels to the right
            marginLeft: 5,
        },
        colon: {
            width: "5%", // Space for the colon
            color: "#000",
            fontSize: 11,
            textAlign: "center", // Center the colon
        },
        colon1: {
            width: "10%", // Space for the colon
            color: "#000",
            fontSize: 11,
            textAlign: "center", // Center the colon
        },
        value: {
            width: "70%", // Allocate space for the value
            color: "#FFFFFF",
            fontSize: 11,
            textAlign: "left", // Align values to the left
        },
        value1: {
            width: "40%", // Allocate space for the value
            color: "#FFFFFF",
            fontSize: 11,
            textAlign: "left", // Align values to the left
        },
        overlay: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1, // Places the background below the content
            opacity: .5,
            backgroundColor: 'rgb(248, 101, 203, .1)'
        },
        lastTableRow: {
            flexDirection: "row",
            borderWidth: 1,
            borderColor: 'darkorange',
            borderRightWidth: 0
        },
        tableRow: {
            flexDirection: "row",
            borderWidth: 1,
            borderColor: 'darkorange',
            borderBottomWidth: 0,
            borderRightWidth: 0
        },
        tableCellHeader: {
            flex: 15,
            textAlign: "left",
            fontWeight: "bold",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: "#000",
        },
        tableCellHeaderSm: {
            flex: 2.25,
            textAlign: "left",
            fontWeight: "bold",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: "#000",
        }, tblCell: {
            flex: 1,
            textAlign: "center",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: "#fff",
        },
        tblCellRest: {
            flex: 12,
            textAlign: "left",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: "#fff",
        },
        tableCell: {
            flex: 4.8,
            textAlign: "left",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: '#fff'

        },
        tableCellCenter: {
            flex: 4.8,
            textAlign: "center",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: '#000',


        },
        tableCellSm: {
            flex: 3.68,
            textAlign: "left",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "#000",

        },
        checkbox: {
            flex: 1, // Allocate small space for the checkbox
            display: "flex",
            justifyContent: "center",
        },
        box: {
            height: 10,
            width: 10,
            borderWidth: 1,
            borderColor: "#FFFFFF",
            marginLeft: 5,
        },
        checked: {
            backgroundColor: "#FFFFFF", // Fill checked box
        },
        tiltedImageContainer: {
            width: '25%',
            height: 200,
            margin: 10,
            border: '1px solid'
        },
        tiltedImg: {
            width: 200,
            height: 200,
            padding: 20,
            overflow: 'hidden',
            // transform: 'rotate(-30deg)',
            border: '8px solid darkorange',
            borderStyle: 'solid',
            // backgroundColor:'blue',
            zIndex: 2, // Places the background below the content
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',

        },
        tiltedText: {
            transform: 'rotate(-30deg)',
        },
        f1: {
            flex: 1
        },
        f4: {
            flex: 4,
        },
        width100pct: {
            width: '100%',
        },
        borderView: {
            width: '100%',
            height: '170px',
            padding: 15,
            alignItems: 'flex-start',
            overflow: 'hidden',
            border: '8px solid #0091cd',
            borderStyle: 'solid',
            backgroundColor: '#fff',
            zIndex: 2, // Places the background below the content
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',

        },
        rect: {
            width: '33%',
            height: 40,
            display: 'flex'
        },
        circle: {
            width: 40,
            height: 40,
            borderRadius: '50%',
            border: '3px solid orange',
            justifyContent: 'center',
            alignItems: 'center',
            // marginTop: 10,
        },
        circleText: {
            fontWeight: 'bold',
            fontSize: 16,
            color: 'orange',
            borderRadius: '8px',
            height: 16,
            width: 16
        },
        sectionContainer: {
            flexDirection: 'row',
            // marginBottom: 20,
            // backgroundColor: '#fde9d9',

        },
        leftSection: {
            flex: 1,
            // border: '2px solid rgba(111,111,111,0.2)',
            padding: 10,
            marginRight: 10,
            textAlign: 'center',
        },
        middleSection: {
            flex: 1,
            padding: 10,
            textAlign: 'center',
        },
        rightSection: {
            flex: 1,
            padding: 10,
            textAlign: 'center',
        },
        balloon: {
            width: 120,
            height: 120,
            position: 'relative',
            backgroundColor: '#FFD700',
            borderRadius: '50%',
            padding: 10,
            margin: 'auto',
        },
        textInBalloon1: {
            position: 'absolute',
            top: '20%',
            left: '20%',
            fontSize: 11,
            textAlign: 'center',
            color: '#000',
        },

        textInBalloon2: {
            position: 'absolute',
            top: '40%',
            left: '24%',
            fontSize: 12,
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#fff',
        },
        image: {
            width: 100,
            height: 100,
            // borderRadius: 10,
            border: '2px solid black',
            objectFit: 'cover',
        },
        box_assessment: {
            width: 70,
            height: 100,
            borderRadius: 10,
            border: 'none',
        },
        purple: {
            backgroundColor: '#7259b8'
        },
        blue: {
            backgroundColor: '#1961ae'
        },
        lightgreen: {
            backgroundColor: '#4dbe07'
        },
        pink: {
            backgroundColor: '#df0384'
        },
        firozi: {
            backgroundColor: '#0091cd'
        },
        box_200: {
            width: 200,
            height: 200,
        },
        emojiRubric:{
            width: 30,
            height: 30,
            objectFit: 'cover'
        },
        emoji: {
            width: 40,
            height: 40,
            objectFit: 'cover'
        },
        tick_img: {
            width: 30,
            height: 30,
            objectFit: 'contain'
        },
        green_tick: {
            width: 35,
            height: 35,
            objectFit: 'contain',
            borderRadius: 4,
            border: '2px solid orange',
            padding: 10
        },
        grey_tick: {
            width: 35,
            height: 35,
            objectFit: 'contain',
            borderRadius: 4,
            border: '1px solid grey',
            opacity: .4,
            padding: 10
        }
    });
    useEffect(() => {
        // console.log('student = ', props, props.studentId, props.studentName, props.classSectionId, props.imgPath, props.lstStudentPdf[0], props.partAColor, props.partBColor)
    }, [])
    const getFormattedDt = (dateStr) => {
        const date = new Date(dateStr);

        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();

        return `${day}-${month}, ${year}`;
    }
    var studentImageUrl = `https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${props.imgPath}`;

    const student = {
        schoolInfo: {
            school: "Sunrise Public School",
            address: "123 Elm Street",
            pin: "560001",
            UDISE: "123456789",
            APAARID: "APAARI001",
            teacherCode: "TCH001",
        },
        partA1: {
            studentId: "S001",
            generalInfo: {
                student: props.studentName,
                rollNo: "123",
                enrollmentNo: "ENR123",
                cls: "10",
                section: "A",
                dob: "2005-05-15",
                age: 10,
                address: "456 Maple Avenue",
                phone: "9876543210",
                photo: "path/to/photo.jpg",
                motherInfo: {
                    parentId: "P001",
                    parent: "Jane Doe",
                    education: "Graduate",
                    occupation: "Teacher",
                },
                fatherInfo: {
                    parentId: "P002",
                    parent: "John Sr.",
                    education: "Postgraduate",
                    occupation: "Engineer",
                },
                guardianInfo: {
                    parentId: "P003",
                    parent: "Uncle Sam",
                    education: "High School",
                    occupation: "Farmer",
                },
                noOfSiblings: 2,
                siblingsAge: [8, 12],
                motherTongue: "English",
                instructionMedium: "English",
                flgRuralUrban: "Urban",
            },
            attendanceInfo: {
                lstAttendance: [
                    { monthId: 1, month: "Apr", workingDays: 22, daysAttended: 20, pctAttendance: "90%" },
                    { monthId: 2, month: "May", workingDays: 20, daysAttended: 18, pctAttendance: "90%" },
                    { monthId: 3, month: "Jun", workingDays: "", daysAttended: "", pctAttendance: "" },
                    { monthId: 4, month: "Jul", workingDays: "", daysAttended: "", pctAttendance: "" },
                    { monthId: 5, month: "Aug", workingDays: "", daysAttended: "", pctAttendance: "" },
                    { monthId: 6, month: "Sep", workingDays: "", daysAttended: "", pctAttendance: "" },
                    { monthId: 7, month: "Oct", workingDays: "", daysAttended: "", pctAttendance: "" },
                    { monthId: 8, month: "Nov", workingDays: "", daysAttended: "", pctAttendance: "" },
                    { monthId: 9, month: "Dec", workingDays: "", daysAttended: "", pctAttendance: "" },
                    { monthId: 10, month: "Jan", workingDays: "", daysAttended: "", pctAttendance: "" },
                    { monthId: 11, month: "Feb", workingDays: "", daysAttended: "", pctAttendance: "" },
                    { monthId: 12, month: "Mar", workingDays: "", daysAttended: "", pctAttendance: "" },
                ],
                lowAttendanceReason: "Medical reasons",
            },
            lstInterest: [
                { interestId: 1, interest: "Reading", interested: true },
                { interestId: 2, interest: "Dancing or Singing", interested: false },
                { interestId: 3, interest: "Playing a musical instrument", interested: false },
                { interestId: 4, interest: "Sports or Games", interested: false },
                { interestId: 5, interest: "Creative writing", interested: false },
                { interestId: 6, interest: "Gardening", interested: false },
                { interestId: 7, interest: "Yoga", interested: false },
                { interestId: 8, interest: "Art", interested: false },
                { interestId: 9, interest: "Craft", interested: false },
                { interestId: 10, interest: "Cooking", interested: false },
                {
                    interestId: 11,
                    interest: "Regular chores at home with significant others (father, mother, guardian, sibling, etc.)",
                    interested: false,
                }
            ],
        },
        partA2: {
            photoFamily: "path/to/family_photo.jpg",
            lstFriend: ["Alice", "Bob", "Charlie"],
            wantToBe: "Scientist",
            myFavourite: {
                color: "Blue",
                flower: "Rose",
                food: "Pizza",
                sport: "Cricket",
                animal: "Dog",
                subject: "Math",
            },
        },
        partB: {
            lstDomain: [
                {
                    domainId: "D001",
                    domain: "Physical Development",
                    domainDesc: "Understanding advanced math concepts",
                    lstGoals: ["Children develop habits that keep them healthy and safe."
                        , "Children develop sharpness in sensorial perceptions."
                        , "Children develop a fit and flexible body."],
                    lstQuestion: [{ goal: "Learn algebra" }, { goal: "Master geometry" }],
                    competency: "High",
                    activityId: "A001",
                    activity: "Solve equations",
                    activityImg: "https://sms.cooledsys.com/sport.png",
                    lstAssessmentQuestion: ["Solve for x", "Find the angle"],
                    assessmentRubric: { a: 10, s: 20, c: 30 },
                    observationalNotes: "Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills.",
                    studentSelfAssessment: {
                        like: 10,
                        easy: 20,
                        lstNeeded: [true, false, true, true, false],
                    },
                    peerAssessmentReceived: {
                        like: "Yes",
                        easy: "No",
                        lstNeeded: [true, false, true, true, false],
                    },
                    peerAssessmentGiven: {
                        like: "Yes",
                        easy: "No",
                        lstNeeded: [true, false, true, true, false],
                    },
                    parentObservation: {
                        lstAvailable: [true, false, true, true, false],
                        comment: "Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home.",
                    },
                },
            ],
        },
        partC: {
            lstPerformanceDescriptor: [
                {
                    domainId: "D001",
                    domain: "Physical Development",
                    general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
                },
                {
                    domainId: "D002",
                    domain: "Physical Development",
                    general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
                },
                {
                    domainId: "D003",
                    domain: "Physical Development",
                    general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
                },
                {
                    domainId: "D004",
                    domain: "Physical Development",
                    general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
                },
                {
                    domainId: "D005",
                    domain: "Physical Development",
                    general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
                },
                {
                    domainId: "D006",
                    domain: "Physical Development",
                    general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
                },
            ],
        },
    };

    return <Document>
        {props.lstStudentPdf.map(function (student, idx) {
            return <>
                {props.cbox1 && <Page size="A4" style={styles.page}>
                    {/* Background with tricolor curved shapes */}
                    <Svg style={styles.overlay} height="100%" width="100%" viewBox="0 0 600 800">
                        {donutPositions.map(({ cx, cy }, index) => {

                            return <React.Fragment key={index}>
                                <Circle
                                    cx={cx} // Random x position
                                    cy={cy} // Random y position
                                    r="40" // Outer circle radius
                                    stroke="#40ffc080" // Light purple fill
                                    strokeWidth="5"
                                    fill="none"
                                />
                                <Circle
                                    cx={cx} // Match outer circle x position
                                    cy={cy} // Match outer circle y position
                                    r="20" // Inner circle radius
                                    stroke="#40f9f9f9" // Matches purple background
                                    strokeWidth="5"
                                    fill="none"
                                />
                            </React.Fragment>
                        })}
                    </Svg>

                    {/* School Information */}
                    <View style={styles.section}>
                        <Text style={styles.header}>School Information</Text>
                        <View style={[styles.row, { marginTop: 10 }]}>
                            <Text style={styles.label}>School:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.school}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Address:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.address}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Pin:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.pin}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Teacher Code:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.teacherCode}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>UDISE:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.udise}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>APAAR ID:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.apaarid}</Text>
                        </View>
                    </View>
                    {/* Content Section */}
                    <View style={styles.section}>
                        <Text style={styles.header}>General Information</Text>
                        <View style={[styles.row, { marginTop: 10 }]}>
                            <Text style={styles.label}>Name</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.partA1.generalInfo.student}</Text>
                        </View>
                        {/* Roll No. Row */}
                        <View style={styles.row}>
                            <View style={styles.firsthalf}>
                                <Text style={styles.label1}>Roll No.</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.rollNo}</Text>
                            </View>
                            <View style={styles.secondhalf}>
                                <Text style={styles.label1}>Registration No.</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.regsNo}</Text>
                            </View>
                        </View>
                        {/* Class Row */}
                        <View style={styles.row}>
                            <Text style={styles.label}>Class</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{props.cls}</Text>
                        </View>
                        {/* Class Row */}
                        <View style={styles.row}>
                            <Text style={styles.label}>Section</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{props.clsSection}</Text>
                        </View>
                        {/* Address Row */}
                        <View style={styles.row}>
                            <Text style={styles.label}>Address</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.partA1.generalInfo.address}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Phone</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.partA1.generalInfo.phone}</Text>
                        </View>

                        <View style={styles.row}>
                            <Text style={styles.label}>Mother Name</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.partA1.generalInfo.motherInfo.parent}</Text>
                        </View>
                        <View style={styles.row}>
                            <View style={styles.firsthalf}>
                                <Text style={styles.label1}>Mother Education</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.motherInfo.education}</Text>
                            </View>
                            <View style={styles.secondhalf}>
                                <Text style={styles.label1}>Occupation</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.motherInfo.occupation}</Text>
                            </View>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Father Name</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.partA1.generalInfo.fatherInfo.parent}</Text>
                        </View>
                        <View style={styles.row}>
                            <View style={styles.firsthalf}>
                                <Text style={styles.label1}>Father Education</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.fatherInfo.education}</Text>
                            </View>
                            <View style={styles.secondhalf}>
                                <Text style={styles.label1}>Occupation</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.fatherInfo.occupation}</Text>
                            </View>
                        </View>
                        <View style={styles.row}>
                            <View style={styles.firsthalf}>
                                <Text style={styles.label1}>Number of siblings</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.noOfSiblings}</Text>
                            </View>
                            <View style={styles.secondhalf}>
                                <Text style={styles.label1}>Siblings' age</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.siblingsAge}</Text>
                            </View>
                        </View>
                        <View style={styles.row}>
                            <View style={styles.firsthalf}>
                                <Text style={styles.label1}>Mother Tongue</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.motherTongue}</Text>
                            </View>
                            <View style={styles.secondhalf}>
                                <Text style={styles.label1}>Instruction Medium</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.schoolInfo.instructionMedium}</Text>
                            </View>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Rural/Urban</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.flgRuralUrban}</Text>
                        </View>


                    </View>
                    <View style={[styles.section, { border: 'none' }]}>
                        {/* Attendance Table */}
                        <Text style={styles.header}>Attendance Information</Text>
                        <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <Text style={styles.tableCellHeader}>Month</Text>
                                {student.partA1.attendanceInfo.lstAttendance.map((record) => (
                                    <Text key={record.monthId} style={styles.tableCell}>
                                        {record.month}
                                    </Text>
                                ))}
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.tableCellHeader}>Working Days</Text>
                                {student.partA1.attendanceInfo.lstAttendance.map((record) => (
                                    <Text key={record.monthId} style={styles.tableCell}>
                                        {record.workingDays}
                                    </Text>
                                ))}
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.tableCellHeader}>Days Attended</Text>
                                {student.partA1.attendanceInfo.lstAttendance.map((record) => (
                                    <Text key={record.monthId} style={styles.tableCell}>
                                        {record.daysAttended}
                                    </Text>
                                ))}
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.tableCellHeader}>% Attendance</Text>
                                {student.partA1.attendanceInfo.lstAttendance.map((record) => (
                                    <Text key={record.monthId} style={styles.tableCell}>
                                        {record.pctAtendance}
                                    </Text>
                                ))}
                            </View>
                        </View>
                        <View style={styles.lastTableRow}>
                            <Text style={styles.tableCellHeaderSm}>Reason</Text>
                            <Text style={styles.tblCellRest}>{student.partA1.attendanceInfo.lowAttendanceReason || ""}</Text>

                        </View>

                    </View>
                    <View style={styles.section}>
                        <Text style={styles.header}>Interest(I am interested in):</Text>

                        {student.partA1.lstInterestRender.map(function (interestArr, interestIdx) {
                            return <View style={[styles.row, { flexWrap: 'wrap', marginTop: 2, marginBottom: 2 }]}>
                                {interestArr.map(function (subItem, subIdx) {
                                    return <View style={[styles.firsthalf]}>
                                        <Text style={[styles.label, { width: 'auto' }]}>{subItem.interest}</Text>
                                        <Text style={styles.colon}>:</Text>
                                        <Image style={{ width: 20, height: 20 }} src={'https://sms.cooledsys.com/tick.png'} />
                                    </View>
                                })}
                            </View>
                        })}
                    </View>

                </Page>}
                {/* Second page with content */}
                {/*line 856*/}
                {props.cbox2 && <Page style={[styles.page, styles.bgPartA2]}>
                    <View style={styles.section}>
                        <Text style={styles.header}>Part-A(2): Me and My Surroundings</Text>

                        {/* Section 1 */}
                        <View style={[styles.sectionContainer]}>
                            {/* Left Part: Image */}
                            <View style={[styles.leftSection, styles.f2, styles.alignCenter, styles.bgWhite]}>
                                <View style={[styles.fDirectionRow]}>
                                    <View style={[styles.fDirectionRow, styles.alignCenter, styles.justifyCenter]}>
                                        <Text style={{
                                            fontSize: 20, textAlign: 'center', fontFamily: 'Ubuntu', color: '#a020f0'
                                        }}>This is ME</Text>
                                    </View>
                                </View>
                                <Image style={[styles.image, styles.tiltedImg]} src={`https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${student.partA1.generalInfo.photo}`} />
                            </View>

                            {/* Middle Part: Text */}
                            <View style={[styles.middleSection, styles.alignCenter, styles.justifyCenter]}>
                                <View style={[styles.justifyCenter, styles.alignCenter, styles.box100px, styles.bRadius70, styles.bgWhite, styles.brownBorder, { marginBottom: 10 }]}>
                                    <View><Text style={[styles.textBrown]}>I AM </Text></View>
                                    <View><Text style={[styles.textBrown, { fontFamily: 'Helvetica-Bold' }]}>{student.partA1.generalInfo.age}</Text></View>
                                    <View> <Text style={[styles.textBrown]}>years OLD</Text></View>
                                </View>
                                <View style={[styles.box100px, styles.justifyCenter, styles.alignCenter, styles.bRadius70, styles.blueBorder, styles.bgWhite]}>
                                    <Text style={[styles.textBlue]}>I live in {student.partA1.generalInfo.address} </Text>
                                </View>
                            </View>

                            {/* Right Part: Balloon with DOB */}
                            <View style={styles.rightSection}>
                                <Svg width="120" height="180" viewBox="0 0 120 180">
                                    {/* Balloon Circle */}
                                    <Circle cx="60" cy="60" r="60" fill="red" stroke="black" strokeWidth="2" />
                                    {/* Curved Thread (Path) */}
                                    <Path
                                        d="M 60,100 C 50,130, 70,150, 60,180" // Cubic Bezier curve (start, control1, control2, end)
                                        stroke="black"
                                        strokeWidth="2"
                                        fill="transparent"
                                    />
                                </Svg>
                                <Text style={styles.textInBalloon1}>My Birthday is on</Text>
                                <Text style={styles.textInBalloon2}>{getFormattedDt(student.partA1.generalInfo.dob)}</Text>
                            </View>
                        </View>
                        <View style={[styles.sectionContainer]}>
                            <View style={[styles.leftSection]}></View>
                            <View style={[styles.leftSection, styles.bgWhite, { flex: 4, height: 320 }]}>
                                <View style={[styles.borderView, styles.fDirectionCol, styles.bDarkOrange, styles.alignStart, styles.width100pct, { flex: 1 }]}>
                                    {/* <View style={[{ flexDirection: 'row', flex: 1 }]}> */}
                                    {/* <View style={[styles.f1, styles.fDirectionRow, styles.justifyCenter, styles.alignCenter]}> */}
                                    <Text style={{ color: '#a020f0', fontSize: 20, marginTop: 10, textAlign: 'center', fontFamily: 'Ubuntu' }}>My family</Text>
                                    {/* </View> */}

                                    {/* </View> */}
                                    <View style={[{ flex: 1, width: '100%' }]}>
                                        <Image style={[styles.image, {
                                            width: 'auto', height: '100%',
                                            borderStyle: 'solid'
                                            , zIndex: 2
                                            , boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
                                        }]}
                                            src={`https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=/home/ubuntu/sms/be/sms_files/31270/student/${student.partA1.generalInfo.familyPhoto}`} />
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.sectionContainer]}>
                            <View style={[{ flexDirection: 'row', flex: 1 }]}>
                                <View style={[styles.leftSection]}>
                                    <View style={[styles.borderView]}>
                                        <Text style={{ marginBottom: 10, textAlign: 'center', fontFamily: 'Ubuntu', fontStyle: 'italic', fontSize: 16, textDecoration: 'underline', textDecorationColor: '#000' }}>My Friends:</Text>
                                        <ul>{
                                            lstFriend?.map(function (item, i) {
                                                return <Text key={"f_" + (i + 1)} style={{ fontWeight: 'bold', color: '#0091cd', fontFamily: 'Ubuntu', fontStyle: 'italic', lineHeight: 1.4, fontSize: 12 }}>• {item}</Text>
                                            })
                                        }</ul>
                                    </View>
                                </View>
                                <View style={[styles.leftSection]}>
                                    <View style={[styles.borderView, { borderColor: '#4dbe07', justifyContent: 'center', alignItems: 'center' }]}>
                                        <Text style={{ marginBottom: 10, fontFamily: 'Ubuntu', fontStyle: 'italic', textAlign: 'center' }}>I WANT TO BE </Text>
                                        <Text style={{ marginBottom: 10, fontFamily: 'Ubuntu', fontStyle: 'italic', textAlign: 'center' }}>A </Text>
                                        <Text style={{ textAlign: 'center', marginBottom: 10, fontFamily: 'Ubuntu', textDecoration: 'underline', textDecorationColor: '#4dbe07', color: '#4dbe07' }}> {student.partA1?.generalInfo?.wantToBe?.toUpperCase()}</Text>
                                        <Text style={{ marginBottom: 10, fontFamily: 'Ubuntu', fontStyle: 'italic', textAlign: 'center' }}>WHEN I GROW UP</Text>
                                    </View>
                                </View>
                                <View style={[styles.leftSection]}>
                                    <View style={[styles.borderView, { width: 160, borderColor: '#ad1ca3' }]}>
                                        <Text style={{ marginBottom: 10, textAlign: 'center', fontFamily: 'Ubuntu', fontStyle: 'italic', fontSize: 16, textDecoration: 'underline', textDecorationColor: '#000' }}>My Favourite:</Text>
                                        <ul>
                                            <Text style={{ fontSize: 12, marginBottom: 15, color: '#ad1ca3' }}> • Color: {myFavourite?.color}</Text>
                                            <Text style={{ fontSize: 12, marginBottom: 15, color: '#ad1ca3' }}> • Food: {myFavourite?.food}</Text>
                                            <Text style={{ fontSize: 12, marginBottom: 15, color: '#ad1ca3' }}> • Animal: {myFavourite?.animal}</Text>
                                            <Text style={{ fontSize: 12, marginBottom: 15, color: '#ad1ca3' }}> • Flower: {myFavourite?.flower}</Text>
                                            <Text style={{ fontSize: 12, marginBottom: 15, color: '#ad1ca3' }}> • Sport: {myFavourite?.sport}</Text>
                                            <Text style={{ fontSize: 12, color: '#ad1ca3' }}> • Subject: {myFavourite?.subject}</Text>
                                        </ul>
                                    </View>
                                </View>

                            </View>
                        </View>
                    </View>
                </Page>}
                {
                    props.cbox3 && student.partB.lstDomain.map(function (item, idx) {
                        return <><Page>

                            <Path
                                d="M 500 10 L 520 10 L 510 30 Z"
                                fill="orange"
                            />
                            <Text style={{ marginTop: 15, color: 'orange', fontSize: 16, textAlign: 'center' }}>Part-B</Text>
                            <View style={styles.section}>
                                <Text style={styles.header}>{item.activityInfo.domain}:{item.activityInfo.domainDesc}</Text>

                                <View style={styles.sectionContainer}>

                                    <View style={[styles.leftPart, { lineHeight: 1.4, paddingLeft: 5 }]}>
                                        <View style={[styles.splitRow]}>
                                            <Text style={{ fontSize: 14, fontWeight: 'bold' }}>Curricular Goals:</Text>
                                        </View>
                                        {/* <View style={[styles.splitRow]}>
                                            <Text style={{ fontSize: 9 }}>(Can choose one or more)</Text>
                                        </View> */}
                                        <View style={[styles.splitRow]}>
                                            <ul>{
                                                lstGoals?.map(function (item, i) {
                                                    return <Text style={{ fontSize: 12 }}>•{item}</Text>
                                                })
                                            }</ul>
                                        </View>
                                    </View>
                                </View>
                            </View>
                            <View style={styles.section}>
                                <Text style={styles.header}>{item.activityInfo.activity}</Text>
                                <View style={[styles.sectionContainer]}>
                                    <View style={[styles.leftPart, { marginTop: 5, flex: 2, lineHeight: 1.4, paddingLeft: 5 }]}>
                                        {/* <View style={styles.splitRow}>
                                            <Text style={{ fontSize: 14, fontWeight: 'bold' }}>{item.activityInfo.activity}</Text>
                                        </View> */}
                                        <View style={[styles.sectionContainer, { flexDirection: 'row', height: 210, justifyContent: 'space-around' }]}>
                                            {/* <View style={{ flex: 1, flexDirection: 'column' }}> */}
                                            <Image style={[styles.tiltedImg, { padding: 0 }]} src={`https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${props.basePathActivity}/${item.activityInfo.activityImgPortrait}`} />
                                            {/* </View> */}
                                            {/* <View style={{ flex: 2, flexDirection: 'column' }}> */}
                                            <Image style={[styles.tiltedImg, { padding: 0, width: 300 }]} src={`https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${props.basePathActivity}/${item.activityInfo.activityImgLandscape}`} />
                                            {/* </View> */}
                                        </View>
                                    </View>

                                </View>
                            </View>
                            <View style={styles.section}>
                                <Text style={styles.header}>ASSESSMENT QUESTIONS</Text>
                                <View style={styles.sectionContainer}>
                                    <View style={[styles.leftPart, { marginTop: 5, lineHeight: 1.4, paddingLeft: 5 }]}>
                                        {lstAssessmentQuestion?.map((it, idx) => (
                                            <View style={[styles.splitRow, { marginBottom: 5 }]} >
                                                <Text style={{ fontSize: 11, fontWeight: 'bold', textAlign: 'left' }}>{it}</Text>
                                            </View>)
                                        )}
                                    </View>
                                </View>
                            </View>
                            <View style={styles.section}>
                                <Text style={styles.header}>ASSESSMENT RUBRIC*</Text>
                                <View style={[styles.sectionContainer]}>
                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                        <View style={{ flexDirection: 'row' }}>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderBottom: '1px solid orange', height: 30, justifyContent: 'center', alignItems: 'center' }]} >
                                                    <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}></Text>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 30, justifyContent: 'center', alignItems: 'center' }]} >
                                                    <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>Stream</Text>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 30, justifyContent: 'center', alignItems: 'center' }]} >
                                                    <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>Mountain</Text>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 30, justifyContent: 'center', alignItems: 'center' }]} >
                                                    <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>Sky</Text>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                                <View style={[styles.sectionContainer]}>
                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                        <View style={{ flexDirection: 'row' }}>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >
                                                    <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>Awareness</Text>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >

                                                    <View style={[{ flex: 1, flex: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                        {item.assessmentRubric.a == 10
                                                            ?
                                                            <Image style={[styles.emojiRubric, {
                                                                borderRadius: '50%', objectFit: 'cover', border: '1px solid grey'
                                                            }]} src={'https://sms.cooledsys.com/stream.jpeg'} />
                                                            : <Text ></Text>}
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >

                                                    <View style={[{ flex: 1, flex: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                        {item.assessmentRubric.a == 20
                                                            ?
                                                            <Image style={[styles.emojiRubric, {
                                                                borderRadius: '50%', objectFit: 'cover', border: '1px solid grey'
                                                            }]} src={'https://sms.cooledsys.com/mountain.jpeg'} />
                                                            : <Text ></Text>}
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >

                                                    <View style={[{ flex: 1, flex: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                        {item.assessmentRubric.a == 30
                                                            ?
                                                            <Image style={[styles.emoji, {
                                                                borderRadius: '50%', objectFit: 'cover', border: '1px solid grey'
                                                            }]} src={'https://sms.cooledsys.com/sky.jpeg'} />
                                                            : <Text ></Text>}
                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={{ flexDirection: 'row' }}>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >
                                                    <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>Sensitivity</Text>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >

                                                    <View style={[{ flex: 1, flex: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                        {item.assessmentRubric.s == 10
                                                            ?
                                                            <Image style={[styles.emojiRubric, {
                                                                borderRadius: '50%', objectFit: 'cover', border: '1px solid grey'
                                                            }]} src={'https://sms.cooledsys.com/stream.jpeg'} />
                                                            : <Text ></Text>}
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >

                                                    <View style={[{ flex: 1, flex: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                        {item.assessmentRubric.s == 20
                                                            ?
                                                            <Image style={[styles.emojiRubric, {
                                                                borderRadius: '50%', objectFit: 'cover', border: '1px solid grey'
                                                            }]} src={'https://sms.cooledsys.com/mountain.jpeg'} />
                                                            : <Text ></Text>}
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >

                                                    <View style={[{ flex: 1, flex: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                        {item.assessmentRubric.s == 30
                                                            ?
                                                            <Image style={[styles.emojiRubric, {
                                                                borderRadius: '50%', objectFit: 'cover', border: '1px solid grey'
                                                            }]} src={'https://sms.cooledsys.com/sky.jpeg'} />
                                                            : <Text ></Text>}
                                                    </View>
                                                </View>
                                            </View>
                                        </View>

                                        <View style={{ flexDirection: 'row' }}>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >
                                                    <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>Creativity</Text>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >

                                                    <View style={[{ flex: 1, flex: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                        {item.assessmentRubric.c == 10
                                                            ?
                                                            <Image style={[styles.emojiRubric, {
                                                                borderRadius: '50%', objectFit: 'cover', border: '1px solid grey'
                                                            }]} src={'https://sms.cooledsys.com/stream.jpeg'} />
                                                            : <Text ></Text>}
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >

                                                    <View style={[{ flex: 1, flex: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                        {item.assessmentRubric.c == 20
                                                            ?
                                                            <Image style={[styles.emojiRubric, {
                                                                borderRadius: '50%', objectFit: 'cover', border: '1px solid grey'
                                                            }]} src={'https://sms.cooledsys.com/mountain.jpeg'} />
                                                            : <Text ></Text>}
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={[styles.leftPart, { flex: .5 }]}>
                                                <View style={[styles.splitRow, { borderLeft: '1px solid orange', borderBottom: '1px solid orange', height: 50, justifyContent: 'center', alignItems: 'center' }]} >

                                                    <View style={[{ flex: 1, flex: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                        {item.assessmentRubric.c == 30
                                                            ?
                                                            <Image style={[styles.emojiRubric, {
                                                                borderRadius: '50%', objectFit: 'cover', border: '1px solid grey'
                                                            }]} src={'https://sms.cooledsys.com/sky.jpeg'} />
                                                            : <Text ></Text>}
                                                    </View>
                                                </View>
                                            </View>
                                        </View>

                                    </View>
                                </View>
                            </View>
                            <View style={{ backgroundColor: 'darkorange', width: '90%', height: 1, position: 'absolute', bottom: 30, right: 30, left: 30 }}></View>
                        </Page >
                            <Page >
                                <Path
                                    d="M 500 10 L 520 10 L 510 30 Z"
                                    fill="orange"
                                />
                                <View style={styles.section}>
                                    <Text style={styles.header}>Teacher's Feedback</Text>
                                    <View style={[styles.sectionContainer, { borderBottom: '1px solid darkorange' }]}>
                                        <View style={styles.leftPart}><View style={styles.splitRow}><Text style={{ color: '#ff000000' }}>abc</Text></View></View>
                                        <View style={[styles.leftPart, { borderLeft: '1px solid darkorange', justifyContent: 'center' }]}><View><Text style={{ fontSize: 12, color: 'brown', textAlign: 'center' }}>Observational Notes</Text></View></View>
                                    </View>
                                    <View style={[styles.sectionContainer, { backgroundColor: '#fff', borderBottom: '1px solid orange' }]}>
                                        <View style={styles.leftPart}>
                                            <View>
                                                {/* <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'center' }}> */}
                                                <Image style={[styles.box_200, { textAlign: 'center' }]} src="https://sms.cooledsys.com/plevel.jpg" />
                                                {/* </Text> */}
                                            </View>
                                        </View>
                                        <View style={[styles.leftPart, { borderLeft: '1px solid darkorange' }]}>
                                            <View style={[styles.splitRow, { padding: 5, marginTop: 10 }]}>
                                                <Text style={{ fontSize: 10, lineHeight: 1.5, family: 'Calibri' }}>
                                                    {observationalNotes[0]}
                                                </Text>
                                            </View>
                                        </View>
                                    </View>
                                    <View style={[styles.sectionContainer, { backgroundColor: '#fff' }]}>
                                        <View style={[styles.splitRow, { padding: 5, margin: 2 }]}>
                                            <View style={[styles.box_assessment, styles.purple, { justifyContent: 'center', display: 'flex' }]}>
                                                <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Self</Text>
                                                <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Assessment</Text>
                                            </View>

                                            <View style={{ flex: 2.4 }}>
                                                <View style={[styles.lightgreen, { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                    <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>I liked doing this work</Text>
                                                </View>
                                                <View style={{ flex: 4, flexDirection: 'row', borderRight: '1px solid #aaa', borderBottom: '1px solid #aaa', justifyContent: 'center' }}>
                                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                                        {/* emoji wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: '10px auto 0px' }}>
                                                            {item.studentSelfAssessment.like !== 0
                                                                && <Image style={[styles.emoji, { textAlign: 'center' }]}
                                                                    src={item.studentSelfAssessment?.like == 10
                                                                        ? "https://sms.cooledsys.com/emoji1.jpg"
                                                                        : (item.studentSelfAssessment?.like == 20
                                                                            ? "https://sms.cooledsys.com/emoji2.jpg"
                                                                            : "https://sms.cooledsys.com/emoji3.jpg"
                                                                        )
                                                                    } />
                                                            }
                                                        </View>
                                                        {/* text wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                            {!!item.studentSelfAssessment?.like && <Text style={{ textAlign: 'center', fontSize: '11' }}>{item.studentSelfAssessment.like == 10 ? 'Yes' : (item.studentSelfAssessment.like == 20 ? 'No' : "Don't Know")}</Text>}
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>

                                            <View style={{ flex: 2.4 }}>
                                                <View style={[styles.pink, { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                    <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>I found this work easy</Text>
                                                </View>
                                                <View style={{ flex: 4, flexDirection: 'row', borderRight: '1px solid #aaa', borderBottom: '1px solid #aaa', justifyContent: 'center' }}>
                                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                                        {/* emoji wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: '10px auto 0px' }}>
                                                            {!!item.studentSelfAssessment?.easy
                                                                && <Image style={[styles.emoji, { textAlign: 'center' }]}
                                                                    src={item.studentSelfAssessment?.easy == 10
                                                                        ? "https://sms.cooledsys.com/emoji1.jpg"
                                                                        : (item.studentSelfAssessment?.easy == 20
                                                                            ? "https://sms.cooledsys.com/emoji2.jpg"
                                                                            : "https://sms.cooledsys.com/emoji3.jpg"
                                                                        )
                                                                    } />
                                                            }
                                                        </View>
                                                        {/* text wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                            {!!item.studentSelfAssessment?.easy && <Text style={{ textAlign: 'center', fontSize: '11' }}>{item.studentSelfAssessment.easy == 10 ? 'Yes' : (item.studentSelfAssessment.easy == 20 ? 'No' : "Don't Know")}</Text>}
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={{ flex: 5 }}>
                                                <View style={[styles.firozi, { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                    <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>To do this work, I needed</Text>
                                                </View>
                                                <View style={{ flex: 4, flexDirection: 'row', borderRight: '1px solid #aaa', borderBottom: '1px solid #aaa', justifyContent: 'center' }}>
                                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                                        <View style={{ flex: 1, flexDirection: 'row' }}>
                                                            <View style={{ flex: 6, flexDirection: 'row', margin: 10 }}>
                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.studentSelfAssessment.lstNeeded[0] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/peer.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Peer</Text>
                                                                    </View>

                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.studentSelfAssessment.lstNeeded[1] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/tch.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Teacher</Text>
                                                                    </View>

                                                                </View>


                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.studentSelfAssessment.lstNeeded[2] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/buk.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Books</Text>
                                                                    </View>

                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.studentSelfAssessment.lstNeeded[3] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/cmp.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Computer</Text>
                                                                    </View>
                                                                </View>

                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.studentSelfAssessment.lstNeeded[4] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/none.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>None</Text>
                                                                    </View>
                                                                </View>
                                                            </View>
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                    </View>

                                    <View style={[styles.sectionContainer, { backgroundColor: '#fff' }]}>

                                        <View style={[styles.splitRow, { padding: 5, margin: 2 }]}>
                                            <View style={[styles.box_assessment, styles.blue, { justifyContent: 'center', display: 'flex' }]}>
                                                <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>My Friend</Text>
                                                <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Assessment</Text>
                                                <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Given</Text>
                                            </View>
                                            <View style={{ flex: 2.4 }}>
                                                <View style={[styles.lightgreen, { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                    <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>liked doing this work</Text>
                                                </View>
                                                <View style={{ flex: 4, flexDirection: 'row', borderRight: '1px solid #aaa', borderBottom: '1px solid #aaa', justifyContent: 'center' }}>
                                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                                        {/* emoji wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: '10px auto 0px' }}>
                                                            {!!item.peerAssessmentGiven.like
                                                                && <Image style={[styles.emoji, { textAlign: 'center' }]}
                                                                    src={item.peerAssessmentGiven.like == 10
                                                                        ? "https://sms.cooledsys.com/emoji1.jpg"
                                                                        : (item.peerAssessmentGiven.like == 20
                                                                            ? "https://sms.cooledsys.com/emoji2.jpg"
                                                                            : "https://sms.cooledsys.com/emoji3.jpg"
                                                                        )
                                                                    } />
                                                            }
                                                        </View>
                                                        {/* text wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                            {!!item.peerAssessmentGiven.like && <Text style={{ textAlign: 'center', fontSize: '11' }}>{item.peerAssessmentGiven.like == 10 ? 'Yes' : (item.peerAssessmentGiven.like == 20 ? 'No' : "Don't Know")}</Text>}
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>

                                            <View style={{ flex: 2.4 }}>
                                                <View style={[styles.pink, { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                    <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>found this work easy</Text>
                                                </View>
                                                <View style={{ flex: 4, flexDirection: 'row', borderRight: '1px solid #aaa', borderBottom: '1px solid #aaa', justifyContent: 'center' }}>
                                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                                        {/* emoji wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: '10px auto 0px' }}>
                                                            {!!item.peerAssessmentGiven.easy
                                                                && <Image style={[styles.emoji, { textAlign: 'center' }]}
                                                                    src={item.peerAssessmentGiven.easy == 10
                                                                        ? "https://sms.cooledsys.com/emoji1.jpg"
                                                                        : (item.peerAssessmentGiven.easy == 20
                                                                            ? "https://sms.cooledsys.com/emoji2.jpg"
                                                                            : "https://sms.cooledsys.com/emoji3.jpg"
                                                                        )
                                                                    } />
                                                            }
                                                        </View>
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                            {!!item.peerAssessmentGiven.easy && <Text style={{ textAlign: 'center', fontSize: '11' }}>{item.peerAssessmentGiven.easy == 10 ? 'Yes' : (item.peerAssessmentGiven.easy == 20 ? 'No' : "Don't Know")}</Text>}
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={{ flex: 5 }}>
                                                <View style={[styles.firozi, { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                    <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>To do this work, needed</Text>
                                                </View>
                                                <View style={{ flex: 4, flexDirection: 'row', borderRight: '1px solid #aaa', borderBottom: '1px solid #aaa', justifyContent: 'center' }}>
                                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                                        <View style={{ flex: 1, flexDirection: 'row' }}>
                                                            <View style={{ flex: 6, flexDirection: 'row', margin: 10 }}>
                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.peerAssessmentGiven.lstNeeded[0] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/peer.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Peer</Text>
                                                                    </View>

                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.peerAssessmentGiven.lstNeeded[1] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/tch.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Teacher</Text>
                                                                    </View>

                                                                </View>


                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.peerAssessmentGiven.lstNeeded[1] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/buk.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Books</Text>
                                                                    </View>

                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.peerAssessmentGiven.lstNeeded[2] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/cmp.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Computer</Text>
                                                                    </View>
                                                                </View>

                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.peerAssessmentGiven.lstNeeded[4] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/none.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>None</Text>
                                                                    </View>
                                                                </View>
                                                            </View>
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                    {/* *********************************************************** */}
                                    <View style={[styles.sectionContainer, { backgroundColor: '#fff' }]}>

                                        <View style={[styles.splitRow, { padding: 5, margin: 2 }]}>
                                            <View style={[styles.box_assessment, styles.purple, { justifyContent: 'center', display: 'flex' }]}>
                                                <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Peer</Text>
                                                <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Assessment</Text>
                                                <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Received</Text>
                                            </View>
                                            <View style={{ flex: 2.4 }}>
                                                <View style={[styles.lightgreen, { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                    <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>liked doing this work</Text>
                                                </View>
                                                <View style={{ flex: 4, flexDirection: 'row', borderRight: '1px solid #aaa', borderBottom: '1px solid #aaa', justifyContent: 'center' }}>
                                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                                        {/* emoji wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: '10px auto 0px' }}>
                                                            {!!item.peerAssessmentReceived.like
                                                                && <Image style={[styles.emoji, { textAlign: 'center' }]}
                                                                    src={item.peerAssessmentReceived.like == 10
                                                                        ? "https://sms.cooledsys.com/emoji1.jpg"
                                                                        : (item.peerAssessmentReceived.like == 20
                                                                            ? "https://sms.cooledsys.com/emoji2.jpg"
                                                                            : "https://sms.cooledsys.com/emoji3.jpg"
                                                                        )
                                                                    } />
                                                            }
                                                        </View>
                                                        {/* text wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                            {!!item.peerAssessmentReceived.like && <Text style={{ textAlign: 'center', fontSize: '11' }}>{item.peerAssessmentReceived.like == 10 ? 'Yes' : (item.peerAssessmentReceived.like == 20 ? 'No' : "Don't Know")}</Text>}
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>

                                            <View style={{ flex: 2.4 }}>
                                                <View style={[styles.pink, { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                    <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>found this work easy</Text>
                                                </View>
                                                <View style={{ flex: 4, flexDirection: 'row', borderRight: '1px solid #aaa', borderBottom: '1px solid #aaa', justifyContent: 'center' }}>
                                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                                        {/* emoji wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: '10px auto 0px' }}>
                                                            {!!item.peerAssessmentReceived.easy
                                                                && <Image style={[styles.emoji, { textAlign: 'center' }]}
                                                                    src={item.peerAssessmentReceived.easy == 10
                                                                        ? "https://sms.cooledsys.com/emoji1.jpg"
                                                                        : (item.peerAssessmentReceived.easy == 20
                                                                            ? "https://sms.cooledsys.com/emoji2.jpg"
                                                                            : "https://sms.cooledsys.com/emoji3.jpg"
                                                                        )
                                                                    } />
                                                            }
                                                        </View>
                                                        {/* text wla div */}
                                                        <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                            {!!item.peerAssessmentReceived.easy && <Text style={{ textAlign: 'center', fontSize: '11' }}>{item.peerAssessmentReceived.easy == 10 ? 'Yes' : (item.peerAssessmentReceived.easy == 20 ? 'No' : "Don't Know")}</Text>}
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={{ flex: 5 }}>
                                                <View style={[styles.firozi, { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                                                    <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>To do this work, needed</Text>
                                                </View>
                                                <View style={{ flex: 4, flexDirection: 'row', borderRight: '1px solid #aaa', borderBottom: '1px solid #aaa', justifyContent: 'center' }}>
                                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                                        <View style={{ flex: 1, flexDirection: 'row' }}>
                                                            <View style={{ flex: 6, flexDirection: 'row', margin: 10 }}>
                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.peerAssessmentReceived.lstNeeded[0] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/peer.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Peer</Text>
                                                                    </View>

                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.peerAssessmentReceived.lstNeeded[1] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/tch.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Teacher</Text>
                                                                    </View>

                                                                </View>


                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.peerAssessmentReceived.lstNeeded[2] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/buk.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Books</Text>
                                                                    </View>

                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.peerAssessmentReceived.lstNeeded[3] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/cmp.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>Computer</Text>
                                                                    </View>
                                                                </View>

                                                                <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Image style={[item.peerAssessmentReceived.lstNeeded[4] ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                            src={"https://sms.cooledsys.com/none.png"} />
                                                                    </View>
                                                                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Text style={{ fontSize: 10, textAlign: 'center' }}>None</Text>
                                                                    </View>
                                                                </View>
                                                            </View>
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                    <View style={[styles.section]}>
                                        <View style={[styles.sectionContainer, { borderBottom: '1px solid darkorange' }]}>
                                            <View style={[styles.leftPart, { justifyContent: 'center', alignItems: 'center', flex: 2 }]}><View style={[styles.splitRow, { justifyContent: 'center' }]}><Text style={{ fontSize: 12, textAlign: 'center', color: 'brown', padding: 2 }}>Parent/Caregiver/Guardian's Observation</Text></View></View>
                                            <View style={[styles.rightPart, { borderLeft: '1px solid darkorange', alignItems: 'center', justifyContent: 'center' }]}><Text style={{ fontSize: 12, color: 'brown', textAlign: 'center', padding: 2 }}>Comments/Remarks</Text></View>
                                        </View>
                                        <View style={[styles.sectionContainer]}>
                                            <View style={[styles.splitRow, { flex: 2, flexDirection: 'row', backgroundColor: '#fff' }]}>
                                                <View style={[styles.leftPart, { flexDirection: 'row', height: 100, margin: 5 }]}>
                                                    <View style={{ flex: 1, width: '100%', flexDirection: 'column' }}>
                                                        <View style={[styles.box_assessment, styles.blue, { justifyContent: 'center', display: 'flex' }]}>
                                                            <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Learning</Text>
                                                            <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Teaching</Text>
                                                            <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Resources</Text>
                                                            <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>at</Text>
                                                            <Text style={{ fontSize: 11, textAlign: 'center', color: '#fff' }}>Home</Text>
                                                        </View>
                                                    </View>
                                                    <View style={{ flex: 5, flexDirection: 'column' }}>
                                                        <View style={{ flex: 1, flexDirection: 'row', borderBottomRightRadius: 6, borderTopRightRadius: 6, border: '1px solid #1961ae', padding: 4, marginLeft: 4 }}>
                                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <Image style={[student.partA1.generalInfo.hpcResourceBooks ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                        src={"https://sms.cooledsys.com/buk.png"} />
                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Text style={{ fontSize: 10, textAlign: 'center' }}>Books</Text>
                                                                </View>

                                                            </View>
                                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <Image style={[student.partA1.generalInfo.hpcResourceNewspaper ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                        src={"https://sms.cooledsys.com/np.png"} />
                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Text style={{ fontSize: 10, textAlign: 'center' }}>Newspaper</Text>
                                                                </View>

                                                            </View>


                                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <Image style={[student.partA1.generalInfo.hpcResourceToys ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                        src={"https://sms.cooledsys.com/sport.png"} />
                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Text style={{ fontSize: 10, textAlign: 'center' }}>Toys/Games</Text>
                                                                </View>

                                                            </View>
                                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <Image style={[student.partA1.generalInfo.hpcResourceComputer ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                        src={"https://sms.cooledsys.com/cmp.png"} />
                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Text style={{ fontSize: 10, textAlign: 'center' }}>Phone/Comp.</Text>
                                                                </View>
                                                            </View>

                                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                                <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                                    <Image style={[student.partA1.generalInfo.hpcResourceInternet ? styles.green_tick : styles.grey_tick, { textAlign: 'center' }]}
                                                                        src={"https://sms.cooledsys.com/internet.png"} />
                                                                </View>
                                                                <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Text style={{ fontSize: 10, textAlign: 'center' }}>Internet</Text>
                                                                </View>
                                                            </View>
                                                        </View>
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={[styles.rightPart, { borderLeft: '1px solid orange' }]}>
                                                <View style={{ marginTop: 2, alignItems: 'center', height: '100%', flexDirection: 'column', flex: 1 }}>
                                                    <Text style={{ fontSize: 10, padding: 2, lineHeight: 1.4 }}>
                                                        {item.parentObservation.comment}
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>
                                    </View>


                                </View>
                                <View style={{ backgroundColor: 'darkorange', width: '90%', height: 1, position: 'absolute', bottom: 30, right: 30, left: 30 }}></View>
                            </Page ></>
                    })}
                {props.cbox4 && <Page >
                    <Path
                        d="M 500 10 L 520 10 L 510 30 Z"
                        fill="darkorange"
                    />
                    <Text style={{ marginTop: 15, color: 'darkorange', fontSize: 15, textAlign: 'center' }}>Part-C</Text>
                    <Text style={{ marginTop: 15, color: 'darkorange', fontSize: 15, textAlign: 'center' }}>SUMMARY FOR THE ACADEMIC YEAR</Text>

                    <Text style={{ marginTop: 15, color: 'black', fontSize: 15, textAlign: 'center' }}>KEY PERFORMANCE DESCRIPTORS</Text>
                    <View style={[styles.section]}>

                        <View style={[styles.sectionContainer, { backgroundColor: '#fff' }]}>
                            <View style={{ flex: 1, flexDirection: 'row' }}>
                                <View style={{ flex: 1, flexDirection: 'row' }}>
                                    <View style={[styles.leftPart, { borderRight: '1px solid darkorange' }]}>
                                        <View style={{ flexDirection: 'row', borderBottom: '1px solid darkorange', padding: 5 }}>
                                            <View style={{ flexDirection: 'column' }}>
                                                <View style={{ flexDirection: 'row', alignItems: 'center', padding: 10 }}>
                                                    <Text style={{ color: 'brown' }}>A</Text>
                                                    <Text style={{ color: 'black' }}>wareness</Text>
                                                </View>
                                                <View style={{ flexDirection: 'row', marginTop: 15 }}>
                                                    <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'center' }}>
                                                        <Image src="https://sms.cooledsys.com/plevel.jpg" style={{ width: 150, height: 150 }} />
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={{ flexDirection: 'row', borderBottom: '1px solid darkorange', padding: 5 }}>
                                            <View style={{ flexDirection: 'column' }}>
                                                <View style={{ flexDirection: 'row', alignItems: 'center', padding: 10 }}>
                                                    <Text style={{ color: 'brown' }}>S</Text>
                                                    <Text style={{ color: 'black' }}>ensitivity</Text>
                                                </View>
                                                <View style={{ flexDirection: 'row', marginTop: 15 }}>
                                                    <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'center' }}>
                                                        <Image src="https://sms.cooledsys.com/plevel.jpg" style={{ width: 150, height: 150 }} />
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={{ flexDirection: 'row', padding: 5 }}>
                                            <View style={{ flexDirection: 'column' }}>
                                                <View style={{ flexDirection: 'row', alignItems: 'center', padding: 10 }}>
                                                    <Text style={{ color: 'brown' }}>C</Text>
                                                    <Text style={{ color: 'black' }}>reativity</Text>
                                                </View>
                                                <View style={{ flexDirection: 'row', marginTop: 15 }}>
                                                    <Text style={{ fontSize: 14, fontWeight: 'bold', textAlign: 'center' }}>
                                                        <Image src="https://sms.cooledsys.com/plevel.jpg" style={{ width: 150, height: 150 }} />
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                    <View style={[styles.leftPart, { border: 'none', flex: 2.2, margin: 25, padding: 5 }]}>
                                        {lstPerformanceDescriptor.map(function (obj, idx) {
                                            return <>
                                                <View key={'pd_' + idx} style={{ flex: 1, width: '90%', padding: 5, margin: 5, marginLeft: idx % 2 == 0 ? 0 : 25, border: idx % 2 == 0 ? '1px solid darkorange' : '1px solid darkviolet', borderLeftWidth: 10, overflow: 'hidden' }}>
                                                    <Text style={{ fontSize: 13, fontFamily: 'Helvetica-Bold', fontWeight: 'bold' }}>{(idx + 1)}. {obj.domain}</Text>
                                                    <View style={{ marginLeft: 15 }}>
                                                        <Text style={{ lineHeight: 1.4, marginTop: 4, fontSize: 12, fontFamily: 'Ubuntu', fontStyle: 'italic' }}>{obj.comment}</Text>
                                                    </View>
                                                </View>
                                            </>

                                        })}
                                    </View>
                                </View>
                            </View>
                        </View>


                    </View>
                    <View style={{ backgroundColor: 'darkorange', width: '90%', height: 1, position: 'absolute', bottom: 30, right: 30, left: 30 }}></View>
                </Page>}
            </>
        })}
    </Document >
}

// Render the PDF
const HpcFoundational = (props) => {
    // console.log(props)
    return <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <StudentPDF key={'spdf_' + props.sliderKey}
            lstStudentPdf={props.lstStudentPdf}
            basePathStudent={props.basePathStudent}
            basePathActivity={props.basePathActivity}
            cbox1={props.cbox1}
            cbox2={props.cbox2}
            cbox3={props.cbox3}
            cbox4={props.cbox4}
            partAColor={props.partAColor}
            partBColor={props.partBColor}
            studentName={props.studentName}
            studentId={props.studentId}
            classSectionId={props.classSectionId}
            imgPath={props.imgPath}
            cls={props.cls}
            clsSection={props.clsSection}
        />
    </PDFViewer>
};

export default HpcFoundational;